import React from 'react';
import clsx from 'clsx';
import BlockTitleGroup from '../block-title-group';
import {useStyles} from './helpers';

const BlockSumBonus = ({formik, promocode}) => {
    const [sumBonus, setSumBonus] = React.useState(false);
    const classes = useStyles();

    return (
        <div>
            <BlockTitleGroup setShowBlock={setSumBonus} showBlock={sumBonus} title="Сумма бонуса" />
            {
                sumBonus &&
                <>
                    <label htmlFor="cashback_percent" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                        <span className={classes.helper}>Процент кэшбека</span>
                        <input 
                            type="number" 
                            name="cashback_percent" 
                            id="cashback_percent" 
                            className={classes.text}
                            value={formik.values.cashback_percent} 
                            onChange={(v) => formik.setFieldValue('cashback_percent', v.target.value)}
                        />
                    </label>
                    <label htmlFor="min_sum_bonus" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                        <span className={classes.helper}>Минимальная сумма бонуса</span>
                        <input 
                            type="number" 
                            name="min_sum_bonus" 
                            id="min_sum_bonus" 
                            className={classes.text}
                            value={formik.values.min_sum_bonus} 
                            onChange={(v) => formik.setFieldValue('min_sum_bonus', v.target.value)}
                        />
                    </label>
                    <label htmlFor="min_sum_balance" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                        <span className={classes.helper}>Минимальная сумма баланса</span>
                        <input 
                            type="text" 
                            name="min_sum_balance" 
                            id="min_sum_balance" 
                            className={classes.text} 
                            value={formik.values.min_sum_balance} 
                            onChange={(v) => {if (!isNaN(+v.target.value)) {formik.setFieldValue('min_sum_balance', v.target.value)}}}/>
                    </label>
                    <label htmlFor="wager" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                        <span className={classes.helper}>Коэффициент для фиксированного бонуса</span>
                        <input 
                            type="number" 
                            name="wager" 
                            id="wager" 
                            className={classes.text} 
                            value={formik.values.wager} 
                            onChange={(v) => formik.setFieldValue('wager', v.target.value)}/>
                    </label>
                </>
            }
        </div>
    )
}

export default BlockSumBonus;